import { render } from "./ImageRadioButtons.vue?vue&type=template&id=18932dc8&scoped=true"
import script from "./ImageRadioButtons.vue?vue&type=script&lang=js"
export * from "./ImageRadioButtons.vue?vue&type=script&lang=js"

import "./ImageRadioButtons.vue?vue&type=style&index=0&id=18932dc8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18932dc8"]])

export default __exports__